import React from 'react';
import { Skeleton } from '@mui/material';

export const ParticipationsLoading: React.FC = () => {
  return (
    <>
      {new Array(3).fill(null).map((_, idx) => (
        <Skeleton key={`skeleton-${idx}`} height={24} />
      ))}
    </>
  );
};
